var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"jpw"},[_c('nav-bar'),_c('router-view'),(_vm.$whitelabel.brand == 'lochlomond')?_c('lochlomond-footer'):_vm._e(),(_vm.$whitelabel.brand == 'sestran')?_c('sestran-footer'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }